//@flow
import { styled } from 'linaria/react';
export const TabHeader =
/*#__PURE__*/
styled("li")({
  name: "TabHeader",
  class: "tjzwvad",
  vars: {
    "tjzwvad-0": [({
      isActive
    }) => isActive ? 'white' : 'inherit']
  }
});
export const TabHeaderList =
/*#__PURE__*/
styled("ul")({
  name: "TabHeaderList",
  class: "tmirla1"
});